import { post, get, put, remove } from '../services/common/common.service';

import {
  erpSalesOrder,
  commonEndPoints,
  customersEndPoints,
} from '../constants/endpoint';

export const fetchErpSalesOrderStaging = (payload) =>
  post(erpSalesOrder.orderStaging, payload);

export const fetchErpSalesOrderStagingByOrderNumber = (payload) =>
  post(erpSalesOrder.orderNo, payload);

export const fetchErpSalesFastSearchItems = (payload) =>
  post(erpSalesOrder.orderNoItems, payload);

export const createManualPurchaseOrder = (payload) =>
  post(erpSalesOrder.createPurchaseOrder, payload);

export const updateManualPurchaseOrder = (payload) =>
  put(erpSalesOrder.createPurchaseOrder, payload);

export const getManualPurchaseOrderNo = () =>
  get(erpSalesOrder.getPurchaseOrderNo);

export const fetchOrderTypes = () => get(commonEndPoints.orderTypes);

export const createMasterCustomerNumber = (payload) =>
  post(erpSalesOrder.masterCustomerNumber, payload);

//Accounting Group Smart Seach - POST API to fetch the data as per payload
export const fetchAccountingGroupsData = (payload) => {
  return post(erpSalesOrder.accountingGroupErpSalesOrder, payload);
};
//Get Customers List On Grid - GET API to fetch the data as per payload
export const byMultipleInputs = (payload) => {
  return post(customersEndPoints.customersByMultipleInputs, payload);
};

export const getImportStatus = (payload) => {
  return get(erpSalesOrder.importStatus, payload);
};

export const getMappingType = (payload) => {
  return get(erpSalesOrder.mappingType, payload);
};

export const fetchSiteData = (payload) => {
  return post(erpSalesOrder.ncrSiteId, payload);
};

export const fetchErpSalesOrderSearch = (payload) =>
  post(erpSalesOrder.orderNo, payload);

export const fetchSiteTypes = () => get(erpSalesOrder.siteType);

export const fetchEntitlementSummary = (payload) =>
  get(`${erpSalesOrder.entitlementSummary}?orderId=${payload.orderId}&pageIndex=${payload.pageIndex}&recordCount=${payload.recordCount}`);

//feth orderItems 
export const fetchOrderItems = (payload) =>
  get(
    `${erpSalesOrder.itemTab.getOrderItems}?orderId=${payload.orderId}&pageIndex=${payload.pageIndex}&recordCount=${payload.recordCount}`,
    payload
  );

//saverplineitems
export const erpSalesOrderLineItemsSave = (payload) =>
  post(erpSalesOrder.itemTab.saveOrderLineItems, payload);
 
//updateErpLineitem
export const updateErpSalesOrderLineItems = (payload) =>
  put(erpSalesOrder.itemTab.updateErpLineItems, payload);
 
//deleteerplineitem
export const deleteErpSalesOrderItems = (payload) =>
  remove(
    `${erpSalesOrder.itemTab.deleteErpLineItems}?orderId=${payload.orderId}&orderItemId=${payload.orderItemId}&shipdate=${payload.shipdate}`,
    payload
  );
 
//getOrderline
export const fetchOrderlineItem = (payload) =>
  get(
    `${erpSalesOrder.itemTab.getOrderLine}?orderId=${payload.orderId}`,
    payload
  );

//Fetching the data for the Order Items
export const fetchERPSalesOrderItems = (payload) => {
  return post(erpSalesOrder.fetchERPSalesOrderItems, payload);
};

//Line Itesm ERP Sales Order Product Name Fetch
export const productNameSearch = (payload) => {
  return post(erpSalesOrder.searchProduct, payload);
};

export const productSearch = (payload) => {
  return post(erpSalesOrder.searchSalesProduct, payload);
};